var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import * as ServiceClient from '../../services/client';
import * as ServiceUtils from '../../services/utils';
import { Loader } from '../../utils/Loader';
import { InputAutoCompleteAdresse } from '../../utils/InputAutoCompleteAdresse';
import { InputSiret } from '../../utils/InputSiret';
import { ClientIcon, LocationIcon, EditIcon, LocationOffIcon, } from '../../utils/Icons';
import { Modal } from '../../utils/Modal';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
import { FormControl, RadioGroup, FormControlLabel, Radio, Stack, FormLabel, Divider, Alert, Grid, } from '@mui/material';
import { ClientSchema } from '../../utils/ValidationSchema';
import { Button } from '../../utils/Button';
import { getIsMobile, getOriginalUser } from '../../services/utilisateur';
import { MapData } from '../../utils/MapData';
import { getAdresseByGoogle } from '../../services/utils';
export var EditionClient = function (props) {
    var ClientId = props.ClientId, onChange = props.onChange;
    var isMobile = getIsMobile();
    var originalUser = getOriginalUser();
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(!ClientId), open = _b[0], setOpen = _b[1];
    var _c = useState('0'), typeRecherche = _c[0], setTypeRecherche = _c[1];
    var _d = useState(null), client = _d[0], setClient = _d[1];
    var _e = useState([]), typesClient = _e[0], setTypesClient = _e[1];
    var _f = useState([]), tags = _f[0], setTags = _f[1];
    var _g = useState([]), trancheEffectifs = _g[0], setTrancheEffectifs = _g[1];
    var _h = useState([]), codeNafApes = _h[0], setCodeNafApes = _h[1];
    var _j = useState([]), pays = _j[0], setPays = _j[1];
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, Promise.all([
                                ServiceClient.getClient(ClientId),
                                ServiceUtils.getTypes('Client'),
                                ServiceUtils.getTypes('Tag'),
                                ServiceUtils.getListe('Client', 'TrancheEffectif'),
                                ServiceUtils.getListe('Client', 'CodeNafApeId'),
                                ServiceUtils.getListe('Client', 'Pays'),
                            ])];
                    case 1:
                        datas = _a.sent();
                        setClient(datas[0]);
                        setTypesClient(datas[1]);
                        setTags(datas[2]);
                        setTrancheEffectifs(datas[3]);
                        setCodeNafApes(datas[4]);
                        setPays(datas[5]);
                        setTypeRecherche(datas[0].IsSociete ? '1' : '0');
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (open) {
            getData();
        }
    }, [open]);
    var handleClose = function () {
        setLoading(true);
        setOpen(false);
        onChange();
    };
    var renderForm = function () {
        return (_jsxs(_Fragment, { children: [!ClientId &&
                    originalUser.Licence.UseVision &&
                    !originalUser.CollaborateurDefaultId ? (_jsx(Alert, __assign({ severity: "error", className: "p-small mb-medium" }, { children: "Il est n\u00E9cessaire de rattacher votre utilisateur \u00E0 un collaborateur pour cr\u00E9er un client. Reconnectez-vous si c'est d\u00E9j\u00E0 le cas." }))) : (_jsx(_Fragment, {})), _jsx(FormikGenerator, { validationSchema: ClientSchema, submitLabel: ClientId ? 'Enregistrer' : 'Ajouter', datas: client, additionalInitialValues: [
                        'Adresse',
                        'Ville',
                        'CodePostal',
                        'Pays',
                        'Commentaire',
                        'Tags',
                        'Longitude',
                        'Latitude',
                    ], renderHeader: function (_a) {
                        var values = _a.values, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched;
                        if (!!client.IsLectureSeule) {
                            return _jsx(_Fragment, {});
                        }
                        return (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 2 }, { children: [_jsx("div", __assign({ style: { width: 230 } }, { children: _jsxs(FormControl, { children: [_jsx(FormLabel, { children: "Rechercher par" }), _jsxs(RadioGroup, __assign({ value: typeRecherche, row: true, onChange: function (e, newValue) { return setTypeRecherche(newValue); } }, { children: [_jsx(FormControlLabel, { value: "0", control: _jsx(Radio, { disabled: !values.IsSociete }), label: "Adresse" }), _jsx(FormControlLabel, { value: "1", control: _jsx(Radio, { disabled: !values.IsSociete }), label: "Siret" })] }))] }) })), typeRecherche === '0' && (_jsx(InputAutoCompleteAdresse, { onChange: function (adresse) {
                                                setFieldValue('Adresse', adresse.Adresse);
                                                setFieldValue('Pays', adresse.Pays);
                                                setFieldValue('Ville', adresse.Ville);
                                                setFieldValue('CodePostal', adresse.CodePostal);
                                                setFieldValue('Latitude', adresse.Latitude);
                                                setFieldValue('Longitude', adresse.Longitude);
                                            } })), typeRecherche === '1' && (_jsx(InputSiret, { onChange: function (client) {
                                                setFieldValue('CodePostal', client.CodePostal);
                                                setFieldValue('Ville', client.Ville);
                                                setFieldValue('Pays', client.Pays);
                                                setFieldValue('Adresse', client.Adresse);
                                                setFieldValue('Latitude', client.Latitude);
                                                setFieldValue('Longitude', client.Longitude);
                                                setFieldValue('RaisonSociale', client.RaisonSociale);
                                                setFieldValue('Siret', client.Siret);
                                                setFieldValue('IsSiege', client.IsSiege);
                                                setFieldValue('TrancheEffectif', client.TrancheEffectif);
                                                setFieldValue('CodeNafApeId', client.CodeNafApeId);
                                                setFieldValue('ClientTypeId', client.ClientTypeId);
                                                setTimeout(function () { return setFieldTouched('Siret', true); });
                                            } }))] })), _jsx(Divider, { className: "m-small" })] }));
                    }, fields: [
                        [
                            {
                                xs: 4,
                                name: 'Actif',
                                label: 'Actif',
                                type: TYPES.BOOLEAN,
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'IsSociete',
                                label: 'Professionnel',
                                type: TYPES.BOOLEAN,
                                afterChange: function (IsSociete) {
                                    setTypeRecherche(IsSociete ? '1' : '0');
                                },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'IsSiege',
                                label: 'Siège',
                                type: TYPES.BOOLEAN,
                                show: function (values) { return values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                        ],
                        [
                            {
                                xs: 4,
                                name: 'Siret',
                                label: 'Siret',
                                type: TYPES.TEXT,
                                isRequired: true,
                                show: function (values) { return values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 8,
                                name: 'RaisonSociale',
                                label: 'Raison sociale',
                                type: TYPES.TEXT,
                                isRequired: true,
                                show: function (values) { return values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                        ],
                        [
                            {
                                xs: 4,
                                name: 'ClientTypeId',
                                label: 'Type',
                                type: TYPES.SELECT,
                                options: typesClient,
                                show: function (values) { return values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'CodeNafApeId',
                                label: 'Code Naf-Ape',
                                type: TYPES.SELECT,
                                options: codeNafApes,
                                show: function (values) { return values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'TrancheEffectif',
                                label: "Tranche d'éffectif",
                                type: TYPES.SELECT,
                                options: trancheEffectifs,
                                show: function (values) { return values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                        ],
                        [
                            {
                                xs: 4,
                                name: 'Civilite',
                                label: 'Civilité',
                                type: TYPES.SELECT,
                                options: [
                                    { label: 'Madame', value: 'Mme' },
                                    { label: 'Monsieur', value: 'Mr' },
                                ],
                                show: function (values) { return !values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'Nom',
                                label: 'Nom',
                                type: TYPES.TEXT,
                                uppercaseFirstChar: true,
                                isRequired: true,
                                show: function (values) { return !values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'Prenom',
                                label: 'Prénom',
                                type: TYPES.TEXT,
                                uppercaseFirstChar: true,
                                show: function (values) { return !values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'Email',
                                label: 'Email',
                                type: TYPES.TEXT,
                                isRequired: true,
                                show: function (values) { return !values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'Telephone',
                                label: 'Téléphone',
                                type: TYPES.TEXT,
                                show: function (values) { return !values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                            {
                                xs: 4,
                                name: 'Mobile',
                                label: 'Mobile',
                                type: TYPES.TEXT,
                                show: function (values) { return !values.IsSociete; },
                                disabled: !!client.IsLectureSeule,
                            },
                        ],
                    ], onSubmit: function (client) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, ServiceClient.postClient(ClientId, client)];
                                case 1:
                                    _a.sent();
                                    handleClose();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, renderContent: function (_a) {
                        var values = _a.values, renderField = _a.renderField, setFieldValue = _a.setFieldValue;
                        return (_jsxs(Grid, __assign({ container: true, spacing: 2, pt: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 8 }, { children: renderField({
                                                    name: 'Adresse',
                                                    label: 'Adresse',
                                                    type: TYPES.TEXT,
                                                    uppercase: true,
                                                    disabled: !!client.IsLectureSeule,
                                                }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 4 }, { children: renderField({
                                                    name: 'CodePostal',
                                                    label: 'Code postal',
                                                    uppercase: true,
                                                    type: TYPES.TEXT,
                                                    disabled: !!client.IsLectureSeule,
                                                }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 8 }, { children: renderField({
                                                    name: 'Ville',
                                                    label: 'Ville',
                                                    uppercase: true,
                                                    type: TYPES.TEXT,
                                                    disabled: !!client.IsLectureSeule,
                                                }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 4 }, { children: renderField({
                                                    name: 'Pays',
                                                    label: 'Pays',
                                                    type: TYPES.SELECT,
                                                    options: pays,
                                                    disabled: !!client.IsLectureSeule,
                                                }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 12 }, { children: _jsxs(Stack, __assign({ direction: isMobile ? 'column' : 'row', justifyContent: "end", spacing: 2 }, { children: [_jsx(Button, __assign({ size: "small", color: "error", startIcon: _jsx(LocationOffIcon, {}), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                                return __generator(this, function (_a) {
                                                                    setFieldValue('Latitude', null);
                                                                    setFieldValue('Longitude', null);
                                                                    return [2 /*return*/];
                                                                });
                                                            }); }, disabled: !!client.IsLectureSeule }, { children: "Supprimer localisation" })), _jsx(Button, __assign({ size: "small", color: "primary", startIcon: _jsx(LocationIcon, {}), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                                var adresse, _a, Latitude, Longitude, e_1;
                                                                return __generator(this, function (_b) {
                                                                    switch (_b.label) {
                                                                        case 0:
                                                                            adresse = [
                                                                                values.Adresse,
                                                                                values.CodePostal,
                                                                                values.Ville,
                                                                            ]
                                                                                .filter(function (value) { return value; })
                                                                                .join(' ');
                                                                            _b.label = 1;
                                                                        case 1:
                                                                            _b.trys.push([1, 3, , 4]);
                                                                            return [4 /*yield*/, getAdresseByGoogle(adresse)];
                                                                        case 2:
                                                                            _a = _b.sent(), Latitude = _a.Latitude, Longitude = _a.Longitude;
                                                                            setFieldValue('Latitude', Latitude);
                                                                            setFieldValue('Longitude', Longitude);
                                                                            return [3 /*break*/, 4];
                                                                        case 3:
                                                                            e_1 = _b.sent();
                                                                            console.error(e_1);
                                                                            return [3 /*break*/, 4];
                                                                        case 4: return [2 /*return*/];
                                                                    }
                                                                });
                                                            }); }, disabled: !!client.IsLectureSeule }, { children: "G\u00E9olocaliser" }))] })) }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(MapData, { diplayPositions: false, Latitude: values.Latitude, Longitude: values.Longitude }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 12 }, { children: renderField({
                                        name: 'Tags',
                                        label: 'Tags',
                                        type: TYPES.SELECT,
                                        options: tags,
                                        multiple: true,
                                        disabled: !!client.IsLectureSeule,
                                    }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 12 }, { children: renderField({
                                        name: 'Commentaire',
                                        label: 'Commentaire',
                                        type: TYPES.TEXT,
                                        multiline: true,
                                        disabled: !!client.IsLectureSeule,
                                    }) }))] })));
                    } })] }));
    };
    return (_jsxs(_Fragment, { children: [ClientId && (_jsx(Button, __assign({ size: "small", color: "primary", onClick: function () {
                    setOpen(true);
                }, endIcon: _jsx(EditIcon, {}) }, { children: "Modifier" }))), open && (_jsx(Modal, __assign({ forceOpen: true, handleCloseModal: handleClose, title: "Client", color: "client", iconTitle: _jsx(ClientIcon, {}) }, { children: loading ? _jsx(Loader, {}) : renderForm() })))] }));
};
//# sourceMappingURL=EditionClient.js.map